module.exports = __webpack_public_path__ + "img/class-listing.93f54d78.jpg";